import { render, staticRenderFns } from "./courseD.vue?vue&type=template&id=67125f84&scoped=true&"
import script from "./courseD.vue?vue&type=script&lang=js&"
export * from "./courseD.vue?vue&type=script&lang=js&"
import style0 from "./courseD.vue?vue&type=style&index=0&id=67125f84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67125f84",
  null
  
)

export default component.exports